import useLanguage from '@op/hooks/useLanguage';
import { useMemo, useState } from 'react';
import { commonVideo, CommonVideoProps } from '../columns/commonVideo';
import { getColumnsAndSortColumns } from '../utils';
import { LanguageType } from '@op/types/common';

type VideoCommonType = { keys: Array<string>; defaultLanguage?: LanguageType };

export function useVideoColumn({
  keys,
  hasHeaderTranlsate,
  wholeGameInfo,
  gameInfo,
  setLanguage: setLocalLanguage,
  defaultLanguage = 'origin',
  sorts,
  setSorts,
  engagementTipsText,
  logBtnId,
  renderKey,
  hasDetailPage,
}: Omit<CommonVideoProps, 'formatMessage' | 'language'> & VideoCommonType) {
  const { formatMessage } = useLanguage();
  const [language, setLanguage] = useState<LanguageType>(defaultLanguage);

  function changeLangauge(value: LanguageType) {
    setLanguage(value);
    setLocalLanguage?.(value);
  }

  const { columns, sortColumns } = useMemo(() => {
    const columnsMap = commonVideo({
      formatMessage,
      language,
      wholeGameInfo,
      renderKey,
      logBtnId,
      gameInfo,
      setLanguage: changeLangauge,
      sorts,
      setSorts,
      engagementTipsText,
      hasHeaderTranlsate,
      hasDetailPage,
    });
    return getColumnsAndSortColumns(keys, columnsMap);
  }, [formatMessage, language, renderKey, keys]);

  return { columns, sortColumns };
}
